import { IPublisher } from '~/src/dash/api/console-api';
import { EBool } from '~/src/dash/api/types/bool';
import { ReportTypeID } from '~/src/dash/apiV2/reporting/reportTypes';
import { ISimpleOption } from '~/src/dash/publicaUI';

export enum EReportPeriod {
  Unknown = 0,
  LastDay,
  Last3Days,
  Last7Days,
  Last15Days,
  CurrentMonth,
  LastMonth,
  CurrentYear,
  Last31Days,
}

export const getReportPeriodStr = (period: EReportPeriod): string => {
  return periods.find((p) => p.value === String(period))?.label || 'Last Day';
};

export const periods: Array<ISimpleOption> = [
  { key: 'period', value: String(EReportPeriod.LastDay), label: 'Last Day' },
  { key: 'period', value: String(EReportPeriod.Last3Days), label: 'Last 3 Days' },
  { key: 'period', value: String(EReportPeriod.Last7Days), label: 'Last 7 Days' },
  { key: 'period', value: String(EReportPeriod.Last15Days), label: 'Last 15 Days' },
  { key: 'period', value: String(EReportPeriod.Last31Days), label: 'Last 31 Days' },
  { key: 'period', value: String(EReportPeriod.CurrentMonth), label: 'Current Month' },
  { key: 'period', value: String(EReportPeriod.LastMonth), label: 'Last Month' },
  { key: 'period', value: String(EReportPeriod.CurrentYear), label: 'Current Year' },
];

export enum EReportFrequency {
  Unknown = 0,
  FrequencyDaily,
  FrequencyWeekly,
  FrequencyMonthly,
}

export const getReportFrequencyStr = (frequency: EReportFrequency): string => {
  return frequencies.find((f) => f.value === String(frequency))?.label || 'Daily';
};

export const frequencies: Array<ISimpleOption> = [
  { key: 'frequency', value: String(EReportFrequency.FrequencyDaily), label: 'Daily' },
  { key: 'frequency', value: String(EReportFrequency.FrequencyWeekly), label: 'Weekly' },
  { key: 'frequency', value: String(EReportFrequency.FrequencyMonthly), label: 'Monthly' },
];

export enum EReportDelivery {
  Unknown = 0,
  Email,
  AWSS3,
}

export const deliveries: Array<ISimpleOption> = [
  { key: 'delivery', value: String(EReportDelivery.Email), label: 'Email' },
  { key: 'delivery', value: String(EReportDelivery.AWSS3), label: 'AWS S3' },
];

export enum EReportPriority {
  Unknown = 0,
  Scheduled = 1,
  Email = 5,
  PublicAPI = 9,
}

export const monthlyScheduledDays: Array<ISimpleOption> = [...Array(31).keys()].map((_, idx) => {
  const value = String(idx + 1);
  return { key: 'scheduledDays', value, label: value };
});

export const weeklyScheduledDays = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
].map((day, idx) => {
  return { key: 'scheduledDays', value: String(idx + 1), label: day };
});

export enum EReportTypeCategory {
  QuickReports = 'Quick Reports',
  InvestigationReports = 'Investigation',
}

export const getReportTypeCategory = (category: number): EReportTypeCategory => {
  return category === 1
    ? EReportTypeCategory.QuickReports
    : EReportTypeCategory.InvestigationReports;
};

export const QUICK_REPORTS = [
  ReportTypeID.AuctionQuickReport,
  ReportTypeID.CampaignQuickReport,
  ReportTypeID.BidderQuickReport,
  ReportTypeID.AdomainQuickReport,
  ReportTypeID.ContentQuickReport,
  ReportTypeID.AppBundleQuickReport,
];

export const showReportingBetaTab = (publisher: IPublisher): boolean => {
  return publisher?.ShowReportingBeta === EBool.EBool_TRUE;
};
